export default function ($http) {
    return function () {
        return $http({
            method: 'GET',
            url: '/api/scannedLetter'
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/services/letters/getNextLetter.js